import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // 1. Importe o Link
import './Resultados.css';

function MeuPerfil() {
  const [minhasAvaliacoes, setMinhasAvaliacoes] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [funcoes, setFuncoes] = useState([]);
  const [loadingAtividades, setLoadingAtividades] = useState(true);

  useEffect(() => {
    axios.get('/api/minhas-avaliacoes/')
      .then(response => {
        setMinhasAvaliacoes(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar minhas avaliações!', error);
      });
    axios.get('/api/minhas-sessoes/')
      .then(response => {
        setAtividades(response.data.atividades || []);
        setFuncoes(response.data.funcoes || []);
      })
      .catch(error => console.error('Erro ao buscar minhas atividades!', error))
      .finally(() => setLoadingAtividades(false));
  }, []);

  const formatarData = (data) => new Date(`${data}T12:00:00`).toLocaleDateString('pt-BR', {
    weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric'
  });

  const rotasCategoria = {
    temas_livres: '/avaliar/temas_livres',
    posteres: '/avaliar/posteres',
    temas_correlatos: '/avaliar/temas_correlatos'
  };

  return (
    <div className="perfil-container">
      <div className="perfil-header">
        <div className="perfil-header-identity">
          <span className="perfil-header-icon">👤</span>
          <div>
            <span className="perfil-eyebrow">CBACV 2026 · Área pessoal</span>
            <h1>Meu Perfil</h1>
            <p>Consulte suas funções, sessões designadas e avaliações realizadas.</p>
          </div>
        </div>
        <Link to="/meu-perfil/alterar-senha" className="perfil-password-btn">
          🔒 Alterar senha
        </Link>
      </div>

      <section className="perfil-section">
        <div className="perfil-section-title">
          <div><span className="perfil-section-eyebrow">RESPONSABILIDADES</span><h2>Minhas atividades</h2></div>
          <div className="perfil-funcoes">
            {funcoes.length ? funcoes.map(funcao => <span key={funcao}>{funcao}</span>) : <span>Usuário</span>}
          </div>
        </div>

        {loadingAtividades ? (
          <div className="perfil-atividades-empty">Carregando suas designações...</div>
        ) : atividades.length === 0 ? (
          <div className="perfil-atividades-empty">
            <strong>Nenhuma sessão designada</strong>
            <span>Quando você for vinculado a uma sessão, ela aparecerá aqui.</span>
          </div>
        ) : (
          <div className="perfil-atividades-grid">
            {atividades.map(atividade => (
              <article className="perfil-atividade-card" key={atividade.id}>
                <div className="perfil-atividade-topo">
                  <span className={`perfil-categoria perfil-categoria-${atividade.categoria}`}>{atividade.categoria_nome}</span>
                  <span className={`perfil-situacao perfil-situacao-${atividade.situacao}`}>
                    {atividade.situacao === 'aberta' ? 'Avaliação aberta' : atividade.situacao === 'encerrada' ? 'Encerrada' : 'Aguardando abertura'}
                  </span>
                </div>
                <h3>{atividade.nome}</h3>
                {atividade.tema && <p className="perfil-atividade-tema">{atividade.tema}</p>}
                <div className="perfil-atividade-meta">
                  <span>📅 {formatarData(atividade.dia)}</span>
                  <span>🕐 {atividade.horario_inicio.slice(0, 5)} – {atividade.horario_fim.slice(0, 5)}</span>
                  {atividade.totem && <span className="perfil-totem">▣ Totem {atividade.totem}</span>}
                </div>
                <div className="perfil-progresso">
                  <div><span>Progresso</span><strong>{atividade.avaliadas}/{atividade.total_trabalhos}</strong></div>
                  <div className="perfil-progresso-track"><span style={{width: `${atividade.total_trabalhos ? (atividade.avaliadas / atividade.total_trabalhos) * 100 : 0}%`}} /></div>
                  <small>{atividade.pendentes} avaliação(ões) pendente(s)</small>
                </div>
                <Link className={`perfil-acessar ${atividade.situacao !== 'aberta' ? 'perfil-acessar-disabled' : ''}`} to={rotasCategoria[atividade.categoria]}>
                  {atividade.situacao === 'aberta' ? 'Acessar avaliação →' : 'Ver programação →'}
                </Link>
              </article>
            ))}
          </div>
        )}
      </section>

      <section className="perfil-section">
        <div className="perfil-section-title"><div><span className="perfil-section-eyebrow">HISTÓRICO</span><h2>Minhas avaliações</h2></div></div>

      {minhasAvaliacoes.length === 0 ? (
        <div className="perfil-empty">
          <span>✓</span>
          <h2>Nenhuma avaliação registrada</h2>
          <p>Seu histórico será exibido aqui após o envio da primeira avaliação.</p>
        </div>
      ) : <div className="perfil-table-wrapper"><table className="perfil-table">
        <thead>
          <tr>
            <th>Data da Avaliação</th>
            <th>Título da Apresentação</th>
            <th>Apresentador(a)</th>
            <th>Sua Nota Final</th>
          </tr>
        </thead>
        <tbody>
          {minhasAvaliacoes.map((avaliacao) => (
            <tr key={avaliacao.id}>
              <td>{new Date(avaliacao.criado_em).toLocaleString('pt-BR')}</td>
              <td>{avaliacao.titulo_apresentacao}</td>
              <td>{avaliacao.apresentador}</td>
              <td className="nota-final">{parseFloat(avaliacao.nota_final_calculada).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table></div>}
      </section>
    </div>
  );
}

export default MeuPerfil;
